import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="pt-40 pb-40 min-h-[60vh] flex items-center" data-testid="page-not-found">
      <div className="container-sp text-center max-w-xl mx-auto">
        <div className="overline">404</div>
        <h1 className="font-serif text-5xl text-[#0D1B2A] mt-3">Page not found.</h1>
        <p className="text-[#4A5568] mt-5">
          The page you're looking for has moved or doesn't exist.
        </p>
        <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="notfound-home-link">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
